// @ts-nocheck
/* eslint-disable */

"use client";

import {
  BlogCard,
  Button,
  Chip,
  Column,
  EmptyState,
  Flex,
  FormField,
  Heading,
  Icon,
  Loader,
  OffCanvas,
  Row,
  Separator,
} from "politicamente-informados-ds";
import { Field, Form, Formik, useFormik } from "formik";
import { IArchiveGrid, IFilters } from "@/lib/wordpress/_types/archiveGrid";
import React, {
  ChangeEvent,
  Suspense,
  useEffect,
  useMemo,
  useState,
} from "react";

import DisplayImage from "@/components/common/DisplayImage/DisplayImage";
import Link from "next/link";
import { WpClientRequest } from "@/lib/wordpress/wpClientRequest";
import { formatDate } from "@/lib/helpers/dateFormate";
import { useGlobalContext } from "@/lib/globalContext";

export default function BlockArchiveGrid({ attrs }: IArchiveGrid) {
  const {
    title,
    variant,
    post_type,
    component,
    per_line = 4,
    per_page,
    showFilters,
    anchor,
    grid,
    className,
  } = attrs || {};
  const colSize = 12 / per_line;
  const [openFilter, setOpenFilter] = useState(false);
  const [loading, setLoading] = useState<boolean | null>(false);
  const [filters, setFilters] = useState<IFilters | null>();
  const [filteredPosts, setFilteredPosts] = useState<
    Record<string, unknown>[] | null
  >(grid?.items);
  const state = useGlobalContext();
  const { lang } = state;

  let activeFilters: string[] = [];
  switch (component) {
    case "BlogCard":
      activeFilters = ["category"];
      break;
  }

  return (
    <Row fluid={true} className={className}>
      {(title || (showFilters && activeFilters.length)) && (
        <Column>
          <Flex align="center">
            {title && (
              <div className="flex-shrink-1">
                <Heading tag="h3" size="h4">
                  {title}
                </Heading>
              </div>
            )}

            {showFilters && activeFilters.length > 0 && (
              <div className="flex-grow-1">
                <Flex align="center" justify="flex-end" style={{ gap: "12px" }}>
                  <Link href={`/blog/`}>
                    <Chip variant="light" hover={true}>
                      {state?.dict?.common?.all}
                    </Chip>
                  </Link>
                  {grid &&
                    grid.categories &&
                    grid.categories.map((category, i) => {
                      return (
                        <Link
                          key={`${category.slug}`}
                          href={`/blog/category/${category.slug}`}
                        >
                          <Chip variant="light" hover={true}>
                            {category.name}
                          </Chip>
                        </Link>
                      );
                    })}
                </Flex>
              </div>
            )}
          </Flex>

          <Separator height="1px" color="currentColor" className="mt-5 mb-6" />
        </Column>
      )}
      {loading ? (
        <Column className="text-center pt-5 pb-5">
          <Loader label={state?.dict?.common?.loading}></Loader>
        </Column>
      ) : (
        <Suspense
          fallback={<Loader label={state?.dict?.common?.loading}></Loader>}
        >
          {filteredPosts && filteredPosts.length !== 0 ? (
            filteredPosts.map((post: Record<string, unknown>, i: number) => {
              if (!post) return false;

              const category =
                (post?.categories as Record<string, unknown | string>) || [];
              const categoryName =
                category && category[0]
                  ? (category[0]?.terms[0]?.name as string)
                  : "";
              const imageElement = (
                <DisplayImage
                  url={post?.image as string}
                  alt={post?.title ? (post?.title as string) : ""}
                  fill={true}
                />
              );

              switch (component) {
                case "BlogCard":
                  return (
                    <Column key={`blogCard-${i}`} sm={12} lg={colSize}>
                      <BlogCard
                        variant={variant}
                        date={formatDate(post?.date as string, "DATE_SHORT")}
                        category={categoryName}
                        imageElement={imageElement}
                        title={post.title}
                        description={post.excerpt}
                        author={post.author}
                        linkElement={
                          <Link
                            href={post.slug as string}
                            aria-label={`Read more about ${post.title}`}
                            role="link"
                            className="linker"
                          ></Link>
                        }
                      />
                    </Column>
                  );
              }
            })
          ) : (
            <Column className="pt-7 pb-5">
              <EmptyState
                variant={"light"}
                label={state?.dict?.common?.noResults}
              ></EmptyState>
            </Column>
          )}
        </Suspense>
      )}
    </Row>
  );
}
